import { render } from "./LightboxGallery.vue?vue&type=template&id=0cb8fdc1"
import script from "./LightboxGallery.vue?vue&type=script&lang=js"
export * from "./LightboxGallery.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/margaretriver.com/margaretriver.com/river/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__